/* FRONT PAGE SCRIPTS */

jQuery(document).ready(function($) {	
	initPreloaderScreen();
	initSliders();		
	expandSlideOnClick();
	// animateBullets();
	animateText();
});

function initPreloaderScreen() {
	setTimeout(function(){
		jQuery('.home #loader').addClass('animated zoomOut');		
	}, 1000);
	setTimeout(function(){		
		jQuery('.home #loader-wrapper').fadeOut('slow');	
		jQuery('.home .off-canvas-wrapper').css('opacity', 1);
	}, 1550);
	initSubmenus();
}


function initSubmenus() {
	jQuery('.top-bar #menu-topnav-1').css('opacity',1);	
/*	setTimeout(function(){
		jQuery('.top-bar .fixedlogo').css('display','block').addClass('animated fadeInLeft');
	}, 800); */
}
	

function initSliders(){	
	var fpPracticeSlider = jQuery('#fp-practice-slider');
	if(fpPracticeSlider.length) {  
	  var practiceSwiper = new Swiper ('#fp-practice-slider' , {
		// Optional parameters
		direction: 'horizontal',
		loop: true,
		autoHeight: true,
		slidesPerView: 1.1,
		spaceBetween: 20,
		// autoplay: {
		// 	delay: 4000,
		// },
		on: {
			slideChange: function () {
			  var activeIndex = this.activeIndex;
			  var realIndex = this.slides.eq(activeIndex).attr('data-swiper-slide-index');
			 jQuery('.swiper-slide').removeClass('swiper-slide-nth-prev-2 swiper-slide-nth-next-2');
			 jQuery('.swiper-slide[data-swiper-slide-index="'+realIndex+'"]').prev().prev().addClass('swiper-slide-nth-prev-2');
			 jQuery('.swiper-slide[data-swiper-slide-index="'+realIndex+'"]').next().next().addClass('swiper-slide-nth-next-2');
			},
		  },
		navigation: {
		  nextEl: '.swiper-button-next',
		  prevEl: '.swiper-button-prev',
		},
		breakpoints: {
			641: {
				spaceBetween: 30,
			},
			1025: {
				slidesPerView: 2.1,
			}
		}
	  })
	  
	  // jQuery('#fp-practice-slider').mouseenter(function(){
		//   practiceSwiper.autoplay.stop();
	  // });
	  // 
	  // jQuery('#fp-practice-slider').mouseleave(function(){
		//   practiceSwiper.autoplay.start();
	  // });
	  
	}
	
	var fpPracticeSlider = jQuery('#fp-faq-slider');
	if(fpPracticeSlider.length) {  
	  var practiceSwiper = new Swiper ('#fp-faq-slider' , {
		// Optional parameters
		direction: 'horizontal',
		loop: true,
		autoHeight: true,
		slidesPerView: 1.1,
		spaceBetween: 20,
		// autoplay: {
		// 	delay: 4000,
		// },
		on: {
			slideChange: function () {
			  var activeIndex = this.activeIndex;
			  var realIndex = this.slides.eq(activeIndex).attr('data-swiper-slide-index');
			 jQuery('.swiper-slide').removeClass('swiper-slide-nth-prev-2 swiper-slide-nth-next-2');
			 jQuery('.swiper-slide[data-swiper-slide-index="'+realIndex+'"]').prev().prev().addClass('swiper-slide-nth-prev-2');
			 jQuery('.swiper-slide[data-swiper-slide-index="'+realIndex+'"]').next().next().addClass('swiper-slide-nth-next-2');
			},
		  },
		navigation: {
		  nextEl: '.swiper-button-next',
		  prevEl: '.swiper-button-prev',
		},
		breakpoints: {
			641: {
				spaceBetween: 30,
			},
			1025: {
				slidesPerView: 2.1,
			}
		}
	  })
	  
	  // jQuery('#fp-practice-slider').mouseenter(function(){
		//   practiceSwiper.autoplay.stop();
	  // });
	  // 
	  // jQuery('#fp-practice-slider').mouseleave(function(){
		//   practiceSwiper.autoplay.start();
	  // });
	  
	}
	
	var fpExpertImageSlider = jQuery('#fp-expert-image');
	if(fpExpertImageSlider.length) {  
	  var expertImageSwiper = new Swiper ('#fp-expert-image' , {
		// Optional parameters
		direction: 'horizontal',
		
		autoHeight: true,
		slidesPerView: 1.1,
		loopAdditionalSlides: 2,
		spaceBetween: 20,
		allowTouchMove: false,
		on: {
			slideChange: function () {
			  var activeIndex = this.activeIndex;
			  var realIndex = this.slides.eq(activeIndex).attr('data-swiper-slide-index');
			 jQuery('.swiper-slide').removeClass('swiper-slide-nth-prev-2 swiper-slide-nth-next-2');
			 jQuery('.swiper-slide[data-swiper-slide-index="'+realIndex+'"]').prev().prev().addClass('swiper-slide-nth-prev-2');
			 jQuery('.swiper-slide[data-swiper-slide-index="'+realIndex+'"]').next().next().addClass('swiper-slide-nth-next-2');
			},
		},
		breakpoints: {
			769: {
				spaceBetween: 20,
				slidesPerView: 1.5,
			},
			1800: {
				slidesPerView: 1.1,
			}
		}
	  })
	}
	
	var fpExpertSlider = jQuery('#fp-expert-text');
	if(fpExpertSlider.length) {  
	  var expertTextSwiper = new Swiper ('#fp-expert-text' , {
		// Optional parameters
		direction: 'horizontal',
				autoHeight: true,
		slidesPerView: 1.1,
		loopAdditionalSlides: 2,
		spaceBetween: 20,
		allowTouchMove: true,
		effect: 'fade',
		// autoplay: {
		// 	delay: 8000,
		// },
		on: {
			slideChange: function () {
			  var activeIndex = this.activeIndex;
			  var realIndex = this.slides.eq(activeIndex).attr('data-swiper-slide-index');
			 jQuery('.swiper-slide').removeClass('swiper-slide-nth-prev-2 swiper-slide-nth-next-2');
			 jQuery('.swiper-slide[data-swiper-slide-index="'+realIndex+'"]').prev().prev().addClass('swiper-slide-nth-prev-2');
			 jQuery('.swiper-slide[data-swiper-slide-index="'+realIndex+'"]').next().next().addClass('swiper-slide-nth-next-2');
			},
		},
		navigation: {
		  nextEl: '.swiper-button-next',
		  prevEl: '.swiper-button-prev',
		},
		breakpoints: {
			641: {
				allowTouchMove: false
			}
		}
	  })
	  
	  if(jQuery(window).width() > 640) {
		 	jQuery('#fp-expert-text').find('.swiper-button-next').on('click', function() {
				expertImageSwiper.slideNext()
			})
			
			jQuery('#fp-expert-text').find('.swiper-button-prev').on('click', function() {
				expertImageSwiper.slidePrev()
			})
	  }
	  else if(jQuery(window).width() < 641) {
		  
		  expertTextSwiper.on('touchMove', function (touchmove) {
		  		if(touchmove.swipeDirection == "next") {
					expertImageSwiper.slideNext()
				}
				
				else if(touchmove.swipeDirection == "prev") {
					expertImageSwiper.slidePrev()
				}
		  });
		  
		  jQuery('#fp-expert-text').find('.swiper-button-next').on('click', function() {
			  expertImageSwiper.slideNext()
		  })
		  
		  jQuery('#fp-expert-text').find('.swiper-button-prev').on('click', function() {
			  expertImageSwiper.slidePrev()
		  })
			
	  }
	  
	  
	    // jQuery('#fp-expert-text').mouseenter(function(){
		// 	expertTextSwiper.autoplay.stop();
		// });
		// 
		// jQuery('#fp-expert-text').mouseleave(function(){
		// 	expertTextSwiper.autoplay.start();
		// });
		
	}
}	

function expandSlideOnClick() {
	if(jQuery(window).width() > 1024) {
		jQuery('#fp-practice .swiper-slide').on('mouseover', function() {
			if(!jQuery(this).hasClass('expanded')) {
				jQuery(this).find('.inner-text').css('max-height', '500px');
				jQuery(this).closest('.swiper-wrapper').css('height', '100%');
				jQuery(this).addClass('expanded');
			}
		})
		
		jQuery('#fp-practice .swiper-slide').on('mouseout', function() {
			jQuery(this).find('.inner-text').css('max-height', '0px');
			jQuery(this).closest('.swiper-wrapper').css('height', 'auto');
			jQuery(this).removeClass('expanded');
		})
	}
	else {
		jQuery('#fp-practice .swiper-slide').on('click', function() {
			if(jQuery(this).hasClass('expanded')) {
				jQuery(this).find('.inner-text').css('max-height', '0px');
				jQuery(this).closest('.swiper-wrapper').css('height', 'auto');
				jQuery(this).removeClass('expanded');
			}
			else {
				jQuery(this).find('.inner-text').css('max-height', '500px');
				jQuery(this).closest('.swiper-wrapper').css('height', '100%');
				jQuery(this).addClass('expanded');
			}
		})
	}
	
}

// function animateBullets() {
// 	jQuery(window).scroll(function() {
// 		var top_of_element = (jQuery("#fp-different .text-section ul").offset().top);
// 		var bottom_of_element = jQuery("#fp-different .text-section ul").offset().top + jQuery("#fp-different .text-section ul").outerHeight();
// 		var bottom_of_screen = jQuery(window).scrollTop() + jQuery(window).innerHeight();
// 		var top_of_screen = jQuery(window).scrollTop();
// 	
// 		if ((bottom_of_screen > top_of_element) && (top_of_screen < bottom_of_element)){
// 			if(!jQuery("#fp-different .text-section ul").hasClass('visible')) {
// 				jQuery("#fp-different .text-section ul").addClass('visible')
// 			}
// 			
// 		} 
// 		// else {
// 		// 	if(jQuery("#fp-different .text-section ul").hasClass('visible')) {
// 		// 		jQuery("#fp-different .text-section ul").removeClass('visible')
// 		// 	}
// 		// }
// 	});
// }

function animateText() {
	jQuery(window).scroll(function() {
		var top_of_element = (jQuery("#fp-quote .cell").offset().top);
		var bottom_of_element = jQuery("#fp-quote .cell").offset().top + jQuery("#fp-quote .cell").outerHeight();
		var bottom_of_screen = jQuery(window).scrollTop() + jQuery(window).innerHeight();
		var top_of_screen = jQuery(window).scrollTop();
	
		if ((bottom_of_screen > top_of_element) && (top_of_screen < bottom_of_element)){
			if(!jQuery("#fp-quote .cell").addClass('animate')) {
				jQuery("#fp-quote .cell").addClass('animate')
			}
			
		} 
		// else {
		// 	if(jQuery("#fp-different .text-section ul").hasClass('visible')) {
		// 		jQuery("#fp-different .text-section ul").removeClass('visible')
		// 	}
		// }
	});
}